import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.333 3.958H6.667S5.625 5.833 5.625 8.333 7.5 12.708 10 12.708s4.375-1.875 4.375-4.375-1.042-4.375-1.042-4.375ZM10 13.125v2.917m-3.542 0h7.084M5.833 8.125h8.334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);